module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_2_25_ccso.329e4461.png";